import { mapActions } from 'vuex'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousRoute = from.path
      vm.checkVisitorItems()
    })
  },
  methods: {
    ...mapActions('visitor', { setVisitorItems: 'setItems', resetItems: 'reset' }),

    // set visitor items for redirection if user comes from visitor page
    checkVisitorItems () {
      if (this.$route.query.id && this.$route.query.condition) {
        const items = {
          id: this.$route.query.id,
          condition: this.$route.query.condition
        }
        this.setVisitorItems(items)
      } else if (this.previousRoute !== '/successsignup' && !this.$route.query.token) {
        this.resetItems()
      }
    }
  }
}
